<template>
  <fvSelect class="form-control select text-right fv-size-md"
            v-model="valData"
            :options="options"
            :placeholder="placeholder"
            :multiple="multiple"
  >
    <template slot="value" slot-scope="scope">
      {{findValueObject(scope.value).text}}
    </template>
    <template slot="option" slot-scope="scope">
      <div class="imageWithName">
            <span class="dropdown-item-text">
              <b>{{scope.option.text || "---"}} </b>
            </span>

            <span class="dropdown-item-text">
                <div>
                  <i v-if="scope.option.value === 'MALE' " class="fa fa-male defaultIcon male"/>
                  <i v-else class="fa fa-female defaultIcon female"/>
                </div>
          </span>
      </div>

    </template>
  </fvSelect>
</template>

<script>
  export default {
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String
      },
      value: {
        type: Array,
      },
      required: [Boolean, Function],
    },
    data() {
      return {
        options: this.$store.state.main.genders,
      }
    },
    computed: {
      valData: {
        get() {
          return this.value ? this.value : this.multiple ? [] : undefined
        },
        set(value) {
          const data = this.multiple ? value : [value]
          this.$emit('input', data)
        }
      }
    },
    methods: {
      findValueObject(value) {
        if (this.multiple)
          return this.options.find((option) => option.value === value) || false;
        else
          return this.options.find((option) => option.value === value[0]) || false;
      },
    }
  }
</script>

<style lang="scss">
.defaultIcon{
  &.female{
    color: #ff879d !important;
  }
  &.male{
    color: blue !important;
  }

}

</style>
